import { createAction } from '@reduxjs/toolkit';

export const modalOpened = createAction<void, 'creativeHub/newFolder/MODAL_OPENED'>(
  'creativeHub/newFolder/MODAL_OPENED',
);
export const modalClosed = createAction<void, 'creativeHub/newFolder/MODAL_CLOSED'>(
  'creativeHub/newFolder/MODAL_CLOSED',
);
export const modalCloseUiEvent = createAction<void, 'creativeHub/newFolder/MODAL_CLOSE_UI_EVENT'>(
  'creativeHub/newFolder/MODAL_CLOSE_UI_EVENT',
);
export const nameChanged = createAction<{ name: string }, 'creativeHub/newFolder/NAME_CHANGED'>(
  'creativeHub/newFolder/NAME_CHANGED',
);
export const confirmed = createAction<void, 'creativeHub/newFolder/CONFIRMED'>(
  'creativeHub/newFolder/CONFIRMED',
);
export const cancelButtonClicked = createAction<
  void,
  'creativeHub/newFolder/CANCEL_BUTTON_CLICKED'
>('creativeHub/newFolder/CANCEL_BUTTON_CLICKED');
export const setInprogress = createAction<
  { inProgress: boolean },
  'creativeHub/newFolder/SET_INPROGRESS'
>('creativeHub/newFolder/SET_INPROGRESS');
export const newFolderButtonClicked = createAction<
  void,
  'creativeHub/newFolder/NEW_FOLDER_BUTTON_CLICKED'
>('creativeHub/newFolder/NEW_FOLDER_BUTTON_CLICKED');
